import * as z from 'zod';
export const NotificationTypeSchema = z.enum([
    'SUCCESS',
    'INFO',
    'ERROR',
    'WARNING',
]);
export const NotificationTopicSchema = z.enum([
    'APPROVALS',
    'DATA_SOURCES',
    'DATA_STATUS',
    'NONE',
    'PROVISION',
    'SAVE_TIMESHEET',
    'SUBMIT_TIMESHEET',
    'TIMESHEETS',
]);
export const NotificationContentSchema = z.object({
    title: z.string(),
    body: z.string(),
});
export const NotificationPayloadSchema = z.object({
    id: z.string(),
    type: NotificationTypeSchema,
    // Follows the Firebase standard for convenience.
    notification: NotificationContentSchema,
    topic: NotificationTopicSchema,
    data: z.record(z.string(), z.any()).optional(),
    timestamp: z.string(),
});
// WebSocket Protocol Messages
// Client -> Server
export const WSAuthMessageSchema = z.object({
    type: z.literal('auth'),
    token: z.string(),
});
export const WSClientMessageSchema = z.discriminatedUnion('type', [
    WSAuthMessageSchema,
]);
// Server -> Client
export const WSNotificationMessageSchema = z.object({
    type: z.literal('notification'),
    data: NotificationPayloadSchema,
});
export const WSAuthenticatedMessageSchema = z.object({
    type: z.literal('authenticated'),
});
export const WSErrorMessageSchema = z.object({
    type: z.literal('error'),
    code: z.string(),
    message: z.string().optional(),
});
export const WSServerMessageSchema = z.discriminatedUnion('type', [
    WSNotificationMessageSchema,
    WSAuthenticatedMessageSchema,
    WSErrorMessageSchema,
]);
//# sourceMappingURL=message-schemas.js.map